import { registerQuery } from '@adornis/baseql/metadata/register.js';
import { context } from '@adornis/baseql/server/context.js';
import { createCalendarFeedToken } from '@adornis/buchungsheld-db/server/calendar-feed-token.js';
import { NotLoggedInError } from '@adornis/users/db/errors.js';

export const getMatchingWeekCalendarFeedToken = registerQuery({
  operationName: 'getMatchingWeekCalendarFeedToken',
  type: () => String,
  resolve: () => async () => {
    if (context.serverContext)
      throw new Error('getMatchingWeekCalendarFeedToken can only be called from a client session');
    if (!context.userID) throw new NotLoggedInError();
    return createCalendarFeedToken('mw-user', context.userID);
  },
});
